export default {
    patient: {
        // Gets associated accounts
        associated: {
            type: "get",
            error: {
                default: "Unable to load account.",
            },
        },
        /*Params:
         * - #patientID?: The patient ID to load associated accounts for
         *  - Defaults to logged-in patient ID
         */

        // Retrieves the primary clinician for patient
        clinician: {
            type: "get",
            error: {
                default: "Unable to load clinician data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to fetch the clinician for
         *  - Defaults to logged-in patient ID
         */

        // Retrieves list of all clinicians for patient
        clinicians: {
            type: "get",
            error: {
                default: "Unable to load clinicians data.",
            },
        },
        cliniciansWithOffice: {
            type: "get",
            error: {
                default: "Unable to load clinicians with office data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to fetch the clinicians for
         *  - Defaults to logged-in patient ID
         */

        // Retrieves list of valid insurers
        insurers: {
            type: "get",
            error: {
                default: "Unable to load list of insurers.",
            },
        },
        // Stedi eligibility check for an insurance on the registration form: { status, message, planName }
        checkRegistrationEligibility: {
            type: "post",
            showLoader: false,
            error: {
                default: "The insurance could not be verified right now.",
            },
        },
        // Insurers with Address1, City, State, Zip and PayerID (to tell apart insurers with the same name)
        insurerList: {
            type: "get",
            showLoader: false,
            error: {
                default: "Unable to load list of insurers.",
            },
        },

        // Retrieves insurance information for patient
        getInsurances: {
            type: "get",
            error: {
                default: "Unable to load insurance data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to fetch insurance for
         *  - Defaults to logged-in patient ID
         */

        // Saves patient insurance information
        saveInsurances: {
            type: "put",
            success: {
                default: "Successfully saved insurance information.",
            },
            error: {
                default: "Failed to save insurance data.",
            },
        },

        saveInsurance: {
            type: "put",
            success: {
                default: "Successfully saved insurance information.",
            },
            error: {
                default: "Failed to save insurance data.",
            },
        },
        deleteInsurance: {
            type: "delete",
            success: {
                default: "Successfully deleted Insurance.",
            },
            error: {
                default: "Failed to delete Insurance.",
            },
        },
        verifyInsurance: {
            type: "get",
            success: {
                default: "Successfully verify Insurance.",
            },
            error: {
                default: "Failed to verify Insurance.",
            },
        },
        // Last saved eligibility result (success or error) for the Verify details popup
        getVerifyDetail: {
            type: "get",
            error: {
                default: "Unable to load verification details.",
            },
        },
        /*Params:
         * - patientInsuranceID: The insurance record
         */

        // Reads an insurance card image/PDF; returns { insurance, review } (nothing is saved)
        analyzeInsuranceCard: {
            type: "post",
            error: {
                400: "Could not read the card. Use a clear JPEG, PNG or PDF photo of the card under 4 MB.",
                default: "Unable to read the insurance card. Please try again or enter it manually.",
            },
        },
        /*Params (FormData):
         * - patientID?: The patient ID
         * - files: front and (optional) back of the card
         */

        // Stores the scanned card images in the patient's Insurance folder
        saveInsuranceCardImages: {
            type: "post",
            error: {
                default: "Insurance saved, but the card image could not be stored.",
            },
        },
        /*Params (FormData):
         * - patientID?: The patient ID
         * - patientInsuranceID: The saved insurance record
         * - files: front and (optional) back of the card
         */
        /*Params:
         * #patientID?: The patient ID to fetch
         *  - Defaults to logged-in patient ID
         * [<"+>]data: The insurance information to save
         */

        // Retireves contracts' sign status for patient
        getContracts: {
            type: "get",
            error: {
                default: "Unable to load contract data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to fetch contract info for
         *  - Defaults to logged-in patient ID
         */

        // Signs contracts for patient
        signContracts: {
            type: "put",
            success: {
                redirect: "/patient",
                default: "Successfully signed contracts.",
            },
            error: {
                default: "Failed to sign contracts.",
            },
        },
        /*Params:
         * <"+>data: The contract info to save
         * =sendEmail: True if email should be sent
         */

        // Retrieves patient profile page
        getProfile: {
            type: "get",
            error: {
                default: "Unable to load profile data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to fetch data for
         *   - Defaults to logged-in patient ID
         * "page: The profile page to fetch data for
         *  - Possible values:
         *   - Overview
         *   - Info
         *   - Dates (date each page was last saved)
         *   - Identity
         *   - Reason
         *   - Family
         *   - Contacts (retrieves no data)
         *   - Medical
         *   - Substance
         *   - Social
         *   - Education
         *   - Employment
         *   - Culture
         */

        // Saves patient profile page
        saveProfile: {
            type: "put",
            success: {
                default: "Successfully saved profile data.",
            },
            error: {
                default: "Failed to save profile data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to save data for
         *   - Defaults to logged-in patient ID
         * "page: The profile page to save
         *  - See above (getProfile) for possible values
         * <"+>data: The page data to save
         */

        // Retrieves list of valid medication names
        medicationNames: {
            type: "get",
            error: {
                default: "Unable to load medication names.",
            },
        },

        // Retrieves medications for patient
        getMedications: {
            type: "get",
            error: {
                default: "Unable to load medication data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to get medications for
         *   - Defaults to logged-in patient ID
         */

        // Saves medications for patient
        saveMedications: {
            type: "put",
            success: {
                default: "Successfully saved medication data.",
            },
            error: {
                default: "Failed to save medication data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to save medications for
         *   - Defaults to logged-in patient ID
         * <"+>[]data: Array of medication objects to save
         *  - If medication name is empty, the associated med is removed
         */

        // Retrieves a contact's data
        getContact: {
            type: "get",
            error: {
                default: "Unable to load contact data.",
            },
        },
        /*Params:
         * #contactID: The contact ID to get data for
         */

        // Retrieves all contacts for a patient
        contacts: {
            type: "get",
            error: {
                default: "Unable to load contacts data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to get contacts for
         *   - Defaults to logged-in patient ID
         */

        // Saves an individual contact
        saveContact: {
            type: "put",
            success: {
                default: "Successfully saved contact data.",
            },
            error: {
                default: "Failed to save contact data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to save this contact under
         *   - Defaults to logged-in patient ID
         * <"+>data: The contact to save
         */
        // Deletes an individual contact
        deleteContact: {
            type: "delete",
            success: {
                default: "Successfully deleted contact.",
            },
            error: {
                default: "Failed to delete contact.",
            },
        },
        /*Params:
         * #contactID: The contact ID to delete
         */

        // Retrieves patient's requested testing
        getTesting: {
            type: "get",
            error: {
                default: "Unable to load testing data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to
         *   - Defaults to logged-in patient ID
         */

        // Saves patient's requested testing
        saveTesting: {
            type: "put",
            //success: {
            //  default: "Successfully saved testing data.",
            //},
            error: {
                default: "Failed to save testing data.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to
         *   - Defaults to logged-in patient ID
         * <"+>data: The testing to request/save
         */

        // Requests verification of current email/phone
        requestChange: {
            type: "post",
            success: {
                default: "Successfully requested change.",
            },
            error: {
                default: "Failed to request change.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to
         *   - Defaults to logged-in patient ID
         * "type: The information to change
         *  - Possible values:
         *   - email
         *   - phone
         */

        // Submits new email/phone to be set
        submitChange: {
            type: "patch",
            success: {
                default: "Successfully submitted change.",
            },
            error: {
                default: "Failed to submit change.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to
         *   - Defaults to logged-in patient ID
         * "type: The information to change
         * - Possible values:
         *  - email
         *  - phone
         * "newValue: The new email/phone to set
         */

        // Verifies the new email/phone is valid
        verifyChange: {
            type: "patch",
            success: {
                redirect: "/",
                default: "Successfully verified change.",
            },
            error: {
                default: "Failed to verify change.",
            },
        },
        /*Params:
         * "type: The information to change
         *  - Possible values:
         *   - email
         *   - phone
         * "code: The verification code sent to the new email/phone
         */

        // Updates or creates a note
        saveNote: {
            type: "put",
            success: {
                default: "Successfully saved note.",
            },
            error: {
                default: "Failed to save note.",
            },
        },
        /*Params:
         * #patientID: The patient ID for this note
         * +note: The note data to save
         * - If NoteID is null, note will be created
         */

        // Gets the patient notes
        getNotes: {
            type: "get",
            error: {
                default: "Failed to get notes.",
            },
        },
        /*Params:
         * #patientID?: The patient ID to get notes for
         *   - Defaults to logged-in patient ID
         */
        sendMessage: {
            type: "put",
            success: {
                default: "Successfully send message.",
            },
            error: {
                default: "Failed to send message.",
            },
        },
        getMessages: {
            type: "get",
            error: {
                default: "Failed to get messages.",
            },
        },
        updateMessage: {
            type: "put",
            error: {
                default: "Failed to update message.",
            },
        },
        deleteMessage: {
            type: "put",
            error: {
                default: "Failed to delete message.",
            },
        },
        getNewMessages: {
            type: "get",
            error: {
                default: "Failed to get new messages.",
            },
        },
        getRefSymptomList: {
            type: "get",
            error: {
                default: "Failed to get symptom list.",
            },
        },
        getRefSymptomNameList: {
            type: "get",
            error: {
                default: "Failed to get symptom name list.",
            },
        },
        getConsentForms: {
            type: "get",
            error: {
                default: "Failed to get consent forms.",
            },
        },
        signConsentForm: {
            type: "put",
            success: {
                default: "Successfully saved consent form.",
            },
            error: {
                default: "Failed to save consent form.",
            },
        },
        getSignedForm: {
            type: "get",
            error: {
                default: "Failed to get sign consent form.",
            },
        },
        getConsentForm: {
            type: "get",
            error: {
                default: "Failed to get consent form.",
            },
        },
        //creates a dream
        saveDream: {
            type: "put",
            success: {
                default: "Successfully saved dream.",
            },
            error: {
                default: "Failed to save dream.",
            },
        },
        saveJournal: {
            type: "put",
            success: {
                default: "Successfully saved journal.",
            },
            error: {
                default: "Failed to save journal.",
            },
        },
        saveReflection: {
            type: "put",
            //success: {
            //    default: "Successfully saved reflection.",
            //},
            error: {
                default: "Failed to save reflection.",
            },
        },
        getJournalHislist: {
            type: "get",
            error: {
                default: "Failed to get journal history list.",
            },
        },
        getJournalHistory: {
            type: "get",
            error: {
                default: "Failed to get journal history.",
            },
        },
        getReflections: {
            type: "get",
            error: {
                default: "Failed to get reflection.",
            },
        },
        getReflectionAvgs: {
            type: "get",
            error: {
                default: "Failed to get reflection avgs.",
            },
        },
        getDreamHislist: {
            type: "get",
            error: {
                default: "Failed to get dream history list.",
            },
        },
        getDreamHistory: {
            type: "get",
            error: {
                default: "Failed to get dream history.",
            },
        },
        saveTermsConditions: {
            type: "put",
        },
        getTermsConditions: {
            type: "get",
            error: {
                default: "Failed to get terms conditions.",
            },
        },

        upcomingAppointments: {
            type: "get",
            error: {
                default: "Failed to get upcoming appointments.",
            },
        },
        availableSlots: {
            type: "get",
            error: {
                default: "Failed to get available slots.",
            },
        },

        bookAppointment: {
            type: "put",
            success: {
                default: "Successfully book appointment.",
            },
            error: {
                default: "Failed to book appointment.",
            },
        },

        getIsConsentWaived: {
            type: "get",
            error: {
                default: "Failed to get consent data.",
            },
        },
    },
    
};
